module.exports = __webpack_public_path__ + "img/icon-ecommerce.d6b51f59.svg";